import { createAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import type { TicketSize } from '../../types'
import ActionTypes from './actionTypes'

type FetchTicketSizeRequest = {
    type: typeof ActionTypes.TICKET_SIZE_ID_FETCH_REQUEST;
    payload: never;
}

type FetchTicketSizeFailure = {
    type: typeof ActionTypes.TICKET_SIZE_ID_FETCH_FAILURE;
    payload: Error;
}

type FetchTicketSizeSuccess = {
    type: typeof ActionTypes.TICKET_SIZE_ID_FETCH_SUCCESS;
    payload: TicketSize;
}

function fetchTicketSize(ticketSizeId: number) {
    return createAction<RootState, TicketSize, never>({
        endpoint: `${HUBBLE_API_TOKEN}/ticket-sizes/${ticketSizeId}`,
        method: 'GET',
        types: [
            ActionTypes.TICKET_SIZE_ID_FETCH_REQUEST,
            ActionTypes.TICKET_SIZE_ID_FETCH_SUCCESS,
            ActionTypes.TICKET_SIZE_ID_FETCH_FAILURE,
        ],
    })
}

export type FetchTicketSizeAction = FetchTicketSizeRequest
    | FetchTicketSizeFailure
    | FetchTicketSizeSuccess

export default fetchTicketSize
